(ns armchair.migrations.textures
  (:require [armchair.math :refer [Point]]))

(def texture-lookup
  {:acid_blob ["characters.png" (Point. 0 0)]
   :agent ["characters.png" (Point. 1 0)]
   :agnes ["characters.png" (Point. 2 0)]
   :aizul ["characters.png" (Point. 3 0)]
   :angel ["characters.png" (Point. 0 1)]
   :antaeus ["characters.png" (Point. 1 1)]
   :asmodeus ["characters.png" (Point. 2 1)]
   :azrael ["characters.png" (Point. 3 1)]
   :azure_jelly ["characters.png" (Point. 0 2)]
   :big_kobold ["characters.png" (Point. 1 2)]
   :blork_the_orc ["characters.png" (Point. 2 2)]
   :boggart ["characters.png" (Point. 3 2)]
   :boris ["characters.png" (Point. 0 3)]
   :brick_house_bottom ["adobe.png" (Point. 6 4)]
   :brick_house_bottom-left ["adobe.png" (Point. 5 4)]
   :brick_house_bottom-right ["adobe.png" (Point. 7 4)]
   :brick_house_middle ["adobe.png" (Point. 6 3)]
   :brick_house_middle-left ["adobe.png" (Point. 5 3)]
   :brick_house_middle-right ["adobe.png" (Point. 7 3)]
   :brick_house_roof_middle ["adobe.png" (Point. 6 1)]
   :brick_house_roof_middle-left ["adobe.png" (Point. 5 1)]
   :brick_house_roof_middle-right ["adobe.png" (Point. 7 1)]
   :brick_house_roof_top ["adobe.png" (Point. 6 0)]
   :brick_house_roof_top-left ["adobe.png" (Point. 5 0)]
   :brick_house_roof_top-right ["adobe.png" (Point. 7 0)]
   :brick_house_top ["adobe.png" (Point. 6 2)]
   :brick_house_top-left ["adobe.png" (Point. 5 2)]
   :brick_house_top-right ["adobe.png" (Point. 7 2)]
   :brick_house_window1 ["adobe.png" (Point. 4 1)]
   :brick_house_window2 ["adobe.png" (Point. 4 0)]
   :brown_ooze ["characters.png" (Point. 1 3)]
   :centaur ["characters.png" (Point. 2 3)]
   :centaur-melee ["characters.png" (Point. 3 3)]
   :centaur_warrior ["characters.png" (Point. 0 4)]
   :centaur_warrior-melee ["characters.png" (Point. 1 4)]
   :cerebov ["characters.png" (Point. 2 4)]
   :crates-single ["Castle2.png" (Point. 9 15)]
   :crates-tower1 ["Castle2.png" (Point. 10 14)]
   :crates-tower2 ["Castle2.png" (Point. 10 15)]
   :crazy_yiuf ["characters.png" (Point. 3 4)]
   :cyclops ["characters.png" (Point. 0 5)]
   :daeva ["characters.png" (Point. 1 5)]
   :dead_squirrel_idle ["characters.png" (Point. 2 5)]
   :death_drake ["characters.png" (Point. 3 5)]
   :deep_elf_annihilator ["characters.png" (Point. 0 6)]
   :deep_elf_blademaster ["characters.png" (Point. 1 6)]
   :deep_elf_conjurer ["characters.png" (Point. 2 6)]
   :deep_elf_death_mage ["characters.png" (Point. 3 6)]
   :deep_elf_demonologist ["characters.png" (Point. 0 7)]
   :deep_elf_fighter ["characters.png" (Point. 1 7)]
   :deep_elf_high_priest ["characters.png" (Point. 2 7)]
   :deep_elf_knight ["characters.png" (Point. 3 7)]
   :deep_elf_mage ["characters.png" (Point. 0 8)]
   :deep_elf_master_archer ["characters.png" (Point. 1 8)]
   :deep_elf_priest ["characters.png" (Point. 2 8)]
   :deep_elf_soldier ["characters.png" (Point. 3 8)]
   :deep_elf_sorcerer ["characters.png" (Point. 0 9)]
   :deep_elf_summoner ["characters.png" (Point. 1 9)]
   :deep_troll ["characters.png" (Point. 2 9)]
   :deformed_elf ["characters.png" (Point. 3 9)]
   :deformed_human ["characters.png" (Point. 0 10)]
   :deformed_orc ["characters.png" (Point. 1 10)]
   :demonspawn ["characters.png" (Point. 2 10)]
   :dirt ["PathAndObjects_0.png" (Point. 10 1)]
   :dispater ["characters.png" (Point. 3 10)]
   :dissolution ["characters.png" (Point. 0 11)]
   :dngn_closed_door ["misc.png" (Point. 1 0)]
   :dngn_open_door ["misc.png" (Point. 2 0)]
   :dngn_unseen ["misc.png" (Point. 3 0)]
   :donald ["characters.png" (Point. 1 11)]
   :dragon ["characters.png" (Point. 2 11)]
   :droog_idle ["characters.png" (Point. 3 11)]
   :duane ["characters.png" (Point. 0 12)]
   :dwarf ["characters.png" (Point. 1 12)]
   :edmund ["characters.png" (Point. 2 12)]
   :elf ["characters.png" (Point. 3 12)]
   :enchantress ["characters.png" (Point. 0 13)]
   :ereshkigal ["characters.png" (Point. 1 13)]
   :erica ["characters.png" (Point. 2 13)]
   :erolcha ["characters.png" (Point. 3 13)]
   :ettin ["characters.png" (Point. 0 14)]
   :eustachio ["characters.png" (Point. 1 14)]
   :eye_of_devastation ["characters.png" (Point. 2 14)]
   :eye_of_draining ["characters.png" (Point. 3 14)]
   :fire_drake ["characters.png" (Point. 0 15)]
   :fire_giant ["characters.png" (Point. 1 15)]
   :frances ["characters.png" (Point. 2 15)]
   :francis ["characters.png" (Point. 3 15)]
   :frederick ["characters.png" (Point. 0 16)]
   :frost_giant ["characters.png" (Point. 1 16)]
   :gastronok ["characters.png" (Point. 2 16)]
   :gate_closed_left ["misc.png" (Point. 4 0)]
   :gate_closed_middle ["misc.png" (Point. 5 0)]
   :gate_closed_right ["misc.png" (Point. 6 0)]
   :gate_open_left ["misc.png" (Point. 7 0)]
   :gate_open_middle ["misc.png" (Point. 8 0)]
   :gate_open_right ["misc.png" (Point. 9 0)]
   :geryon ["characters.png" (Point. 3 16)]
   :giant_amoeba ["characters.png" (Point. 0 17)]
   :giant_eyeball ["characters.png" (Point. 1 17)]
   :giant_orange_brain ["characters.png" (Point. 2 17)]
   :girl_idle ["characters.png" (Point. 3 17)]
   :gloorx_vloq ["characters.png" (Point. 0 18)]
   :glowing_shapeshifter ["characters.png" (Point. 1 18)]
   :gnoll ["characters.png" (Point. 2 18)]
   :goblin ["characters.png" (Point. 3 18)]
   :golden_dragon ["characters.png" (Point. 0 19)]
   :golden_eye ["characters.png" (Point. 1 19)]
   :goth_idle ["characters.png" (Point. 2 19)]
   :grain-green ["PathAndObjects_0.png" (Point. 7 10)]
   :grain-yellow ["PathAndObjects_0.png" (Point. 8 10)]
   :grass ["PathAndObjects_0.png" (Point. 1 11)]
   :grass_dirt_bottom ["PathAndObjects_0.png" (Point. 10 2)]
   :grass_dirt_bottom-left ["PathAndObjects_0.png" (Point. 9 2)]
   :grass_dirt_bottom-right ["PathAndObjects_0.png" (Point. 11 2)]
   :grass_dirt_left ["PathAndObjects_0.png" (Point. 9 1)]
   :grass_dirt_right ["PathAndObjects_0.png" (Point. 11 1)]
   :grass_dirt_top ["PathAndObjects_0.png" (Point. 10 0)]
   :grass_dirt_top-left ["PathAndObjects_0.png" (Point. 9 0)]
   :grass_dirt_top-right ["PathAndObjects_0.png" (Point. 11 0)]
   :grass_stone_bottom ["PathAndObjects_0.png" (Point. 1 2)]
   :grass_stone_bottom-left ["PathAndObjects_0.png" (Point. 0 2)]
   :grass_stone_bottom-right ["PathAndObjects_0.png" (Point. 2 2)]
   :grass_stone_left ["PathAndObjects_0.png" (Point. 0 1)]
   :grass_stone_right ["PathAndObjects_0.png" (Point. 2 1)]
   :grass_stone_top ["PathAndObjects_0.png" (Point. 1 0)]
   :grass_stone_top-left ["PathAndObjects_0.png" (Point. 0 0)]
   :grass_stone_top-right ["PathAndObjects_0.png" (Point. 2 0)]
   :great_orb_of_eyes ["characters.png" (Point. 3 19)]
   :greater_naga ["characters.png" (Point. 0 20)]
   :griffon ["characters.png" (Point. 1 20)]
   :grinder ["characters.png" (Point. 2 20)]
   :grum ["characters.png" (Point. 3 20)]
   :guardian_serpent ["characters.png" (Point. 0 21)]
   :gustav ["characters.png" (Point. 1 21)]
   :halfling ["characters.png" (Point. 2 21)]
   :harold ["characters.png" (Point. 3 21)]
   :harpy ["characters.png" (Point. 0 22)]
   :hell_knight ["characters.png" (Point. 1 22)]
   :hi-tops_idle ["characters.png" (Point. 2 22)]
   :hill_giant ["characters.png" (Point. 3 22)]
   :hippogriff ["characters.png" (Point. 0 23)]
   :hobgoblin ["characters.png" (Point. 1 23)]
   :house_arch_top ["adobe.png" (Point. 3 2)]
   :house_bottom ["adobe.png" (Point. 1 4)]
   :house_bottom_left ["adobe.png" (Point. 0 4)]
   :house_bottom_right ["adobe.png" (Point. 2 4)]
   :house_door_bottom ["adobe.png" (Point. 3 4)]
   :house_middle-left ["adobe.png" (Point. 0 3)]
   :house_middle-right ["adobe.png" (Point. 2 3)]
   :house_roof_bottom ["adobe.png" (Point. 1 2)]
   :house_roof_bottom-left ["adobe.png" (Point. 0 2)]
   :house_roof_bottom-right ["adobe.png" (Point. 2 2)]
   :house_roof_bottom2 ["adobe.png" (Point. 1 3)]
   :house_roof_middle ["adobe.png" (Point. 1 1)]
   :house_roof_middle-left ["adobe.png" (Point. 0 1)]
   :house_roof_middle-right ["adobe.png" (Point. 2 1)]
   :house_roof_top ["adobe.png" (Point. 1 0)]
   :house_roof_top-left ["adobe.png" (Point. 0 0)]
   :house_roof_top-right ["adobe.png" (Point. 2 0)]
   :house_window1 ["adobe.png" (Point. 3 0)]
   :house_window2 ["adobe.png" (Point. 3 1)]
   :hugo ["characters.png" (Point. 2 23)]
   :human ["characters.png" (Point. 3 23)]
   :human_monk_ghost ["characters.png" (Point. 0 24)]
   :human_slave ["characters.png" (Point. 1 24)]
   :hydra5 ["characters.png" (Point. 2 24)]
   :ice_beast ["characters.png" (Point. 3 24)]
   :ice_dragon ["characters.png" (Point. 0 25)]
   :ijyb ["characters.png" (Point. 1 25)]
   :ilsuiw ["characters.png" (Point. 2 25)]
   :ilsuiw_water ["characters.png" (Point. 3 25)]
   :iron_dragon ["characters.png" (Point. 0 26)]
   :iron_troll ["characters.png" (Point. 1 26)]
   :iron_troll_monk_ghost ["characters.png" (Point. 2 26)]
   :jelly ["characters.png" (Point. 3 26)]
   :jessica ["characters.png" (Point. 0 27)]
   :joseph ["characters.png" (Point. 1 27)]
   :josephine ["characters.png" (Point. 2 27)]
   :jozef ["characters.png" (Point. 3 27)]
   :killer_klown ["characters.png" (Point. 0 28)]
   :kirke ["characters.png" (Point. 1 28)]
   :kobold ["characters.png" (Point. 2 28)]
   :kobold_demonologist ["characters.png" (Point. 3 28)]
   :lernaean_hydra ["characters.png" (Point. 0 29)]
   :lindwurm ["characters.png" (Point. 1 29)]
   :logs-large ["PathAndObjects_0.png" (Point. 4 10)]
   :logs-single ["PathAndObjects_0.png" (Point. 6 10)]
   :logs-small ["PathAndObjects_0.png" (Point. 5 10)]
   :lom_lobon ["characters.png" (Point. 2 29)]
   :louise ["characters.png" (Point. 3 29)]
   :manticore ["characters.png" (Point. 0 30)]
   :mara ["characters.png" (Point. 1 30)]
   :margery ["characters.png" (Point. 2 30)]
   :market-crate1 ["PathAndObjects_0.png" (Point. 12 7)]
   :market-crate2 ["PathAndObjects_0.png" (Point. 13 7)]
   :market-crate3 ["PathAndObjects_0.png" (Point. 14 7)]
   :market-crate4 ["PathAndObjects_0.png" (Point. 15 7)]
   :market-crate5 ["PathAndObjects_0.png" (Point. 12 9)]
   :market-crate6 ["PathAndObjects_0.png" (Point. 13 9)]
   :market-crate7 ["PathAndObjects_0.png" (Point. 14 9)]
   :market-crate8 ["PathAndObjects_0.png" (Point. 15 9)]
   :maud ["characters.png" (Point. 3 30)]
   :maurice ["characters.png" (Point. 0 31)]
   :menkaure ["characters.png" (Point. 1 31)]
   :merfolk_aquamancer ["characters.png" (Point. 2 31)]
   :merfolk_aquamancer_water ["characters.png" (Point. 3 31)]
   :merfolk_fighter ["characters.png" (Point. 0 32)]
   :merfolk_fighter_water ["characters.png" (Point. 1 32)]
   :merfolk_impaler ["characters.png" (Point. 2 32)]
   :merfolk_impaler_water ["characters.png" (Point. 3 32)]
   :merfolk_javelineer ["characters.png" (Point. 0 33)]
   :merfolk_javelineer_water ["characters.png" (Point. 1 33)]
   :merfolk_plain ["characters.png" (Point. 2 33)]
   :merfolk_plain_water ["characters.png" (Point. 3 33)]
   :mermaid ["characters.png" (Point. 0 34)]
   :mermaid_water ["characters.png" (Point. 1 34)]
   :minotaur ["characters.png" (Point. 2 34)]
   :mnoleg ["characters.png" (Point. 3 34)]
   :mottled_dragon ["characters.png" (Point. 0 35)]
   :murray ["characters.png" (Point. 1 35)]
   :naga ["characters.png" (Point. 2 35)]
   :naga_mage ["characters.png" (Point. 3 35)]
   :naga_warrior ["characters.png" (Point. 0 36)]
   :necromancer ["characters.png" (Point. 1 36)]
   :nellie ["characters.png" (Point. 2 36)]
   :nergalle ["characters.png" (Point. 3 36)]
   :nessos ["characters.png" (Point. 0 37)]
   :norbert ["characters.png" (Point. 1 37)]
   :norris ["characters.png" (Point. 2 37)]
   :ogre ["characters.png" (Point. 3 37)]
   :ogre_mage ["characters.png" (Point. 0 38)]
   :ooze ["characters.png" (Point. 1 38)]
   :orb_guardian ["characters.png" (Point. 2 38)]
   :orc ["characters.png" (Point. 3 38)]
   :orc_high_priest ["characters.png" (Point. 0 39)]
   :orc_knight ["characters.png" (Point. 1 39)]
   :orc_priest ["characters.png" (Point. 2 39)]
   :orc_sorcerer ["characters.png" (Point. 3 39)]
   :orc_warlord ["characters.png" (Point. 0 40)]
   :orc_warrior ["characters.png" (Point. 1 40)]
   :orc_wizard ["characters.png" (Point. 2 40)]
   :polyphemus ["characters.png" (Point. 3 40)]
   :potted_plant-red ["PathAndObjects_0.png" (Point. 7 13)]
   :potted_plant-yellow ["PathAndObjects_0.png" (Point. 11 9)]
   :prince_ribbit ["characters.png" (Point. 0 41)]
   :psyche ["characters.png" (Point. 1 41)]
   :pulsating_lump ["characters.png" (Point. 2 41)]
   :punker ["characters.png" (Point. 3 41)]
   :purgy ["characters.png" (Point. 0 42)]
   :quicksilver_dragon ["characters.png" (Point. 1 42)]
   :red_wall-bottom ["misc.png" (Point. 13 0)]
   :red_wall-bottom-left ["misc.png" (Point. 11 0)]
   :red_wall-bottom-right ["misc.png" (Point. 12 0)]
   :red_wall-center ["misc.png" (Point. 14 0)]
   :red_wall-left ["misc.png" (Point. 15 0)]
   :red_wall-right ["misc.png" (Point. 16 0)]
   :red_wall-top ["misc.png" (Point. 18 0)]
   :red_wall-top-left ["misc.png" (Point. 17 0)]
   :red_wall_top-right ["misc.png" (Point. 19 0)]
   :rock_troll ["characters.png" (Point. 2 42)]
   :rock_troll_monk_ghost ["characters.png" (Point. 3 42)]
   :rourke ["characters.png" (Point. 0 43)]
   :roxanne ["characters.png" (Point. 1 43)]
   :royal_jelly ["characters.png" (Point. 2 43)]
   :rupert ["characters.png" (Point. 3 43)]
   :saint_roka ["characters.png" (Point. 0 44)]
   :serpent_of_hell ["characters.png" (Point. 1 44)]
   :shadow_dragon ["characters.png" (Point. 2 44)]
   :shapeshifter ["characters.png" (Point. 3 44)]
   :shining_eye ["characters.png" (Point. 0 45)]
   :sigmund ["characters.png" (Point. 1 45)]
   :siren ["characters.png" (Point. 2 45)]
   :siren_water ["characters.png" (Point. 3 45)]
   :snorg ["characters.png" (Point. 0 46)]
   :sonja ["characters.png" (Point. 1 46)]
   :sphinx ["characters.png" (Point. 2 46)]
   :stairs ["misc.png" (Point. 20 0)]
   :steam_dragon ["characters.png" (Point. 3 46)]
   :stone ["PathAndObjects_0.png" (Point. 1 1)]
   :stone_2 ["PathAndObjects_0.png" (Point. 2 3)]
   :stone_bush ["PathAndObjects_0.png" (Point. 2 4)]
   :stone_giant ["characters.png" (Point. 0 47)]
   :stone_grass_bottom-left ["PathAndObjects_0.png" (Point. 0 4)]
   :stone_grass_bottom-right ["PathAndObjects_0.png" (Point. 1 4)]
   :stone_grass_top-left ["PathAndObjects_0.png" (Point. 0 3)]
   :stone_grass_top-right ["PathAndObjects_0.png" (Point. 1 3)]
   :storm_dragon ["characters.png" (Point. 1 47)]
   :swamp_dragon ["characters.png" (Point. 2 47)]
   :swamp_drake ["characters.png" (Point. 3 47)]
   :terence ["characters.png" (Point. 0 48)]
   :tiamat ["characters.png" (Point. 1 48)]
   :titan ["characters.png" (Point. 2 48)]
   :tree1-bottom1 ["32x32_map_tile_v3.1.png" (Point. 0 12)]
   :tree1-bottom2 ["32x32_map_tile_v3.1.png" (Point. 1 12)]
   :tree1-top1 ["32x32_map_tile_v3.1.png" (Point. 2 12)]
   :tree1-top2 ["32x32_map_tile_v3.1.png" (Point. 3 12)]
   :tree1-trunk1 ["32x32_map_tile_v3.1.png" (Point. 0 13)]
   :tree1-trunk2 ["32x32_map_tile_v3.1.png" (Point. 1 13)]
   :tree2_middle-left ["mountain_landscape.png" (Point. 7 14)]
   :tree2_middle-right ["mountain_landscape.png" (Point. 8 14)]
   :tree2_top-left ["mountain_landscape.png" (Point. 7 13)]
   :tree2_top-right ["mountain_landscape.png" (Point. 8 13)]
   :tree3_bottom-left ["mountain_landscape.png" (Point. 7 15)]
   :tree3_bottom-right ["mountain_landscape.png" (Point. 8 15)]
   :troll ["characters.png" (Point. 3 48)]
   :two_headed_ogre ["characters.png" (Point. 0 49)]
   :urug ["characters.png" (Point. 1 49)]
   :vault_guard ["characters.png" (Point. 2 49)]
   :wall ["misc.png" (Point. 21 0)]
   :water1 ["32x32_map_tile_v3.1.png" (Point. 5 21)]
   :water2 ["32x32_map_tile_v3.1.png" (Point. 3 21)]
   :wiglaf ["characters.png" (Point. 3 49)]
   :wizard ["characters.png" (Point. 0 50)]
   :wood_panel1 ["32x32_map_tile_v3.1.png" (Point. 10 1)]
   :wood_panel2 ["32x32_map_tile_v3.1.png" (Point. 10 2)]
   :wood_panel3 ["32x32_map_tile_v3.1.png" (Point. 7 1)]
   :wyvern ["characters.png" (Point. 1 50)]
   :xtahua ["characters.png" (Point. 2 50)]
   :yaktaur ["characters.png" (Point. 3 50)]
   :yaktaur-melee ["characters.png" (Point. 0 51)]
   :yaktaur_captain ["characters.png" (Point. 1 51)]
   :yaktaur_captain-melee ["characters.png" (Point. 2 51)]
   :yakuza_idle ["characters.png" (Point. 3 51)]})
